import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueDisqus from 'vue-disqus'
import { VueMasonryPlugin } from 'vue-masonry'
import VueGtag from "vue-gtag"
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import store from './store'

if (process.env.VUE_APP_BUGSNAG) {
  Bugsnag.start({
    apiKey: process.env.VUE_APP_BUGSNAG,
    plugins: [new BugsnagPluginVue()]
  })
  Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)
}

if (process.env.VUE_APP_ANALYTICS) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_ANALYTICS }
  })
}

if (process.env.VUE_APP_DISQUS) {
  Vue.use(VueDisqus, {
    shortname: process.env.VUE_APP_DISQUS
  })
}

Vue.use(VueMasonryPlugin)
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
